import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
export const FETCH_FEEDBACK_DATA_SUCCESS = 'FETCH_FEEDBACK_DATA_SUCCESS';
export const FETCH_FEEDBACK_DATA_FAILED = 'FETCH_FEEDBACK_DATA_FAILED';
export const SET_FEEDBACK_DATA_SUCCESS = 'SET_FEEDBACK_DATA_SUCCESS';

export function updateFeedbackResponse(uuid, data,options){
    return dispatch => {
        let request = {
          url:  API_PROTOCOL + BE_SERVER_ENDPOINT  + '/2.1/feedback-question-bank/add-feedback-response/users/'+uuid,
          params: options,
          data : data,
          method: 'PUT'
        }
        axios(request)
        .then((response)=> {
            dispatch({
                type: SET_FEEDBACK_DATA_SUCCESS
            })
        })
    }    
}

export const fetchFeedbackData = (uuid, options) => async(dispatch) => {
    await axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/2.1/feedback-question-bank/users/' + uuid , {
            params: options} )
        .then((response)=> {
            dispatch({
                type: FETCH_FEEDBACK_DATA_SUCCESS,
                payload: response.data.payload
            })
        },
        (error) => {
            dispatch({
                type: FETCH_FEEDBACK_DATA_FAILED,
                payload: error
                })
            }
        )
    }




